<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" *ngIf="!currentView">
  <mat-tab label="Pricing">
    <!-- Pricing -->
    <div class="p-4">
      <sbnb-button [fullWidth]="true" [type]="'secondary'" (clicked)="setViewDynamicPricing()">
        <div class="flex gap-2 justify-between items-center">
          <div class="flex flex-col gap-2 text-left button-content">
            <div class="flex flex-row gap-4 justify-between">
              <div class="font-bold">Dynamic Pricing</div>
              <sbnb-badge
                *ngIf="$dynamicPricingOptions()"
                [context]="$dynamicPricingOn() ? 'positive' : 'exuberant'"
                volume="high">
                {{ $dynamicPricingOn() ? 'ON' : 'NEW' }}
              </sbnb-badge>
            </div>
            <div class="text-xs text-night">Included in your plan</div>
          </div>
          <sbnb-icon [icon]="'chevron-right'" [size]="20"></sbnb-icon>
        </div>
      </sbnb-button>
    </div>
  </mat-tab>
</mat-tab-group>

<div id="dynamic-pricing" class="pt-6 h-full" *ngIf="currentView === viewEnum.DYNAMIC_PRICING">
  <sbnb-sidebar-property-dynamic-pricing
    (hide)="currentView = undefined"
    [property]="property"></sbnb-sidebar-property-dynamic-pricing>
</div>
